import React from "react";

const CheckOrWarn: React.FC<{
  bool: boolean;
}> = ({ bool }) => {
  return bool === true ? (
    <i className="fa fa-check-circle fa-fw icon-success" />
  ) : (
    <i className="fa fa-warning fa-fw icon-danger" />
  );
};

export default CheckOrWarn;
